var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_2137_7558)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9575 16.8254C31.9645 15.9232 30.9147 15.4478 29.8753 15.3711C28.5944 15.2766 27.47 15.799 26.6677 16.6081C25.1062 18.1827 24.6056 21.0583 26.5865 23.0484C26.5953 23.0572 26.6042 23.0658 26.6133 23.0742L32.3432 28.3743C32.6892 28.6944 33.2233 28.6944 33.5693 28.3743L39.2992 23.0742L39.3201 23.0542C41.3313 21.0703 40.8275 18.192 39.2596 16.6175C38.4546 15.8092 37.3273 15.2871 36.0451 15.379C35.0039 15.4537 33.9517 15.9259 32.9575 16.8254ZM18.6876 28.0002H15.3594V35.223L18.661 38.5246C20.0155 39.8792 21.8527 40.6402 23.7683 40.6402H34.3194C35.8152 40.6402 37.0279 39.4274 37.0279 37.9316C37.0279 36.4357 35.8152 35.223 34.3194 35.223H29.3052C29.131 35.8126 28.8112 36.3684 28.3459 36.8337C26.858 38.3214 24.4457 38.3214 22.9579 36.8337L20.3396 34.2152C19.8988 33.7747 19.8988 33.06 20.3396 32.6193C20.7803 32.1785 21.4949 32.1785 21.9356 32.6193L24.5539 35.2376C25.1603 35.844 26.1434 35.844 26.7498 35.2376C27.2954 34.692 27.3501 33.8415 26.914 33.2348L23.7949 30.1157C22.4404 28.7611 20.6032 28.0002 18.6876 28.0002Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_7558",
    x1: -6.00482,
    y1: 61.32,
    x2: 67.2446,
    y2: 57.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonations);
export default __webpack_public_path__ + "static/media/donations.215ea702650b73041f6acad63ca797d5.svg";
export { ForwardRef as ReactComponent };